// extracted by mini-css-extract-plugin
export default {"productVideo":"productVideo_Kmnsq","hasFirstPlayed":"hasFirstPlayed_pvD0c"};